module.exports = __webpack_public_path__ + "assets/img/619e9756ef1016a1d80c731c7523f786.png";